<style>
  .step {
    font-size: 18px;
    font-weight: 600;
  }


  li {
    font-size: 15px;
    font-weight: 500;
  }
</style>

<div *ngIf="caseData">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Follow the instructions below to complete : {{ formName }}</span>
      <button (click)="onNoClick()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <!-- <h4 style='text-align : center ;  font-weight: 600; '>Follow the instructions below to complete : {{ form }}</h4> -->
  <span *ngIf="isError" class="error" style="text-align: center">The file was not found. Please try again later or
    contact support.</span>
  <div class="p-12">
    <div class="mdl-grid">
      <!-- Step 1 block start-->
      <div *ngIf="!caseIsBond" class="mdl-cell mdl-cell--2-col">
        <div class="step"> Step 1: </div>
      </div>
      <div *ngIf="!caseIsBond" class="mdl-cell mdl-cell--10-col">
        <div class="step"> Download your form {{ form }} </div>
        <!-- <br> -->
        <ul class='circle'>
          <li>Download and print the form</li>
          <li>All details should be filled except notary and your signature sections</li>
          <li>After downloading the form close the dialog and you can reopen it when you are ready to upload after notarization</li>
        </ul>
        <a [href]="downloadPDFLink" [class.loading]="downloadFormLoader" [disabled]="downloadFormLoader" target="_blank"
          mat-raised-button color="accent">
          <div class="spinner"></div>
          <span class="label" style="text-transform: uppercase">Download Form {{ form }}</span>
        </a>
        <br>
        <hr>
      </div>
      <!-- Step 1 block end -->
      <!-- Step 2 block start -->
      <div class="mdl-cell mdl-cell--2-col">
        <div class='step'><span *ngIf="!caseIsBond">Step 2:</span></div>
      </div>
      <div class="mdl-cell mdl-cell--10-col" *ngIf="!caseIsBond">
        <div class='step'> Take the form to a Notary public to be notarized</div>
        <ul>
          <li> Review the document for accuracy before notarization</li>
        </ul>
        <hr *ngIf="!caseIsBond">
      </div>
      <!-- Step 2 block end -->
      <!-- Step 3 block start-->
      <div class="mdl-cell mdl-cell--2-col">
        <div class='step'><span *ngIf="!caseIsBond">Step 3:</span></div>
      </div>
      <div class="mdl-cell mdl-cell--10-col">
        <div class="step" *ngIf="caseIsBond">Report and fees</div>
        <div class="step" *ngIf="!caseIsBond">Upload notarized form</div>
        <br>
        <div>
          <ul *ngIf="!caseIsBond">
            <li style='margin-top : -22px '>Upload PDF file with scanned image</li>
          </ul>
          <ul *ngIf="caseIsBond">
            <li style='margin-top : -22px '>Upload PDF version of report</li>
            <li style='margin-top : -22px '>Upload PDF version of fees</li>
          </ul>
          <button [class.loading]="loading" *ngIf="!reports" [disabled]="loading" type="button" mat-raised-button color="accent"
            (click)="docUpload.click()">
            <div class="spinner"></div>
            <span class="label" style="text-transform: uppercase">Upload Form {{ form }}</span>
          </button>

          <button [class.loading]="loading" *ngIf="reports" [disabled]="loading || loadingTwo || upload1" type="button" mat-raised-button color="accent"
            (click)="docUpload2.click()">
            <div class="spinner"></div>
            <span class="label" style="text-transform: uppercase" *ngIf="!upload1">Upload report</span>
            <span class="label" style="text-transform: uppercase" *ngIf="upload1">Uploaded report</span>
          </button>

          <button [class.loading]="loadingTwo" *ngIf="reports" [disabled]="loadingTwo || loading || upload2" type="button" mat-raised-button color="accent"
            (click)="docUpload3.click()">
            <div class="spinner"></div>
            <span class="label" style="text-transform: uppercase" *ngIf="!upload2">Upload fees</span>
            <span class="label" style="text-transform: uppercase" *ngIf="upload2">Uploaded fees</span>
          </button>
          <input hidden type="file" #docUpload (change)="upload($event)" />
          <input hidden type="file" #docUpload2 (change)="fileUpload($event)" />
          <input hidden type="file" #docUpload3 (change)="fileUpload2($event)" />

        </div>
        <hr *ngIf="!caseIsBond">
      </div>
      <!-- Step 3 block end-->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/downloadUpload/downloadUpload.component.html